export default {
  additional_questions: 'elite',
  default_gender: 'female',
  tags: ['ללאמענה', 'יוני21', 'ינואר21', 'אוגוסט20', 'נדל"ן', 'שוק ההון', 'הייטק', 'יועמ"ש', 'בכיר', 'ליטיגציה', 'מסחרי', 'אנגלית_שפת_אם', 'נזיקין', 'שיווק', 'רו"ח', 'אנליסט', 'פיתוח עסקי', 'כלכלן'],
  is_job_title_mandatory: false,
  auto_description: {
    show_certification_date: true,
    show_degree: true
  }
}
